<div class="list-item-column">

  <div class="list-item-row-header" [ngClass]="{'opened' : opened}">
    <div class="text-block fs-16 align-self-center">{{item?.title}}</div>
    <div class="text-block text-end icon-container">
      <i *ngFor="let icon of icons" [class]="'demo-icon vertical-middle align-self-center ' + getIconClass(icon) + ' fs-30'"></i>
    </div>
  </div>
</div>
